import {request} from "../../Base/HTTP";
export async function getReferenceTypeCount() {
    return await request('/api/reference-type-count', {});
}